import { format, parseISO } from 'date-fns';
import { costFormatter } from '../../format';

export const formatDate = date => format(parseISO(date), 'EEEE, MMMM d');

export const calculateGrandTotals = orders => {
  const totals = orders.reduce(
    (acc, order) => {
      acc.totalTax += parseFloat(order.total_tax);
      acc.subtotal += parseFloat(order.total_ex_tax);
      acc.totalPrice += parseFloat(order.total_price);
      acc.discountAmount += parseFloat(order.total_discount);

      const petItem = order.items.find(item => item.pet_id);
      acc.orderTotal += parseFloat(petItem.price);
      return acc;
    },
    {
      totalTax: 0,
      subtotal: 0,
      totalPrice: 0,
      discountAmount: 0,
      orderTotal: 0,
    },
  );
  totals.totalTax = totals.totalTax > 0 ? costFormatter(totals.totalTax) : '';
  totals.subtotal = costFormatter(totals.subtotal);
  totals.totalPrice = costFormatter(totals.totalPrice);
  totals.discountAmount = costFormatter(totals.discountAmount);
  totals.orderTotal = costFormatter(totals.orderTotal);
  return totals;
};

export const formatDeliveryAddress = address => ({
  street: [address.address1, address.address2].filter(Boolean).join(', '),
  city: address.city,
  state: address.state,
  zip: address.zip_code,
});

export const formatPets = pets =>
  pets.map(pet => ({
    ...pet,
    breeds: pet.breeds.map(breed => breed.name),
  }));

export const formatOrderSummary = (pets, subscriptions, orders, products) =>
  pets.map(pet => {
    const { total_ex_tax, subtotal_ex_tax } = orders.find(
      order => order.items[0].pet_id === pet.id,
    );

    const { next_delivery_target, frequency, sku } = subscriptions.find(
      subscription => subscription.pet_id === pet.id,
    );

    const {
      variants: [{ recipes, price_per_week }],
    } = products.find(product => product.variants[0].sku === sku);

    return {
      petName: pet.name,
      breeds: pet.breeds.map(breed => breed.name),
      price: costFormatter(subtotal_ex_tax),
      discountedPrice: costFormatter(total_ex_tax),
      pricePerWeek: costFormatter(price_per_week),
      frequencyInWeeks: frequency,
      deliveryNext: formatDate(next_delivery_target),
      recipes,
    };
  });
